/*
 * @Description:存放获取数据的常量
 * @Author: et_wl,Yaojh
 * @Date: 2019-07-24 11:02:28
 * @LastEditTime: 2020-09-01 11:53:07
 * @LastEditors: kayvor
 */

// token
export const SET_TOKEN = 'SET_TOKEN'
export const CLEAR_TOKEN = 'CLEAR_TOKEN'

// appInfo
export const CHECK_WEIXIN = 'CHECK_WEIXIN'
export const INIT_APP_INFO = 'INIT_APP_INFO'
export const SET_APP_CLASS = 'SET_APP_CLASS'
export const LOGIN_OUT = 'LOGIN_OUT'
export const WX_CODE_ERR = 'WX_CODE_ERR'

// editOrderInfo
export const GET_LOCATION = 'GET_LOCATION' // 获取地理定位方法
export const GET_CAR_NO_LIST = 'GET_CAR_NO_LIST' // 获取车牌归属地
export const EDIT_CAR_NO = 'EDIT_CAR_NO' // 获取车牌归属地
export const GET_SMS_CODE = 'GET_SMS_CODE' // 获取短信验证码
export const GET_SEND_SMS_COUNT = 'GET_SEND_SMS_COUNT' // 获取验证码次数
export const GET_GRAPH_VALIDATE_CODE = 'GET_GRAPH_VALIDATE_CODE'
export const GET_REGION_BY_TYPE_ID = 'GET_REGION_BY_TYPE_ID' // 获取地区记录
export const EDIT_REGION = 'EDIT_REGION' // 编辑地址地区记录

// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

// home
export const GET_MARKETING_INFO_REQUEST = 'GET_MARKETING_INFO_REQUEST'
export const GET_MARKETING_INFO_SUCCESS = 'GET_MARKETING_INFO_SUCCESS'
export const GET_MARKETING_INFO_FAILURE = 'GET_MARKETING_INFO_FAILURE'
export const GET_MARKETING_IMGS_REQUEST = 'GET_MARKETING_IMGS_REQUEST'
export const GET_MARKETING_IMGS_SUCCESS = 'GET_MARKETING_IMGS_SUCCESS'
export const GET_MARKETING_IMGS_FAILURE = 'GET_MARKETING_IMGS_FAILURE'
// export const UPDATE_MARKETING_IMGS_PARAMS = 'UPDATE_MARKETING_IMGS_PARAMS'

// editAddress
export const SET_ADDRESS_INFO = 'SET_ADDRESS_INFO'
export const CLEAR_ADDRESS_INFO = 'CLEAR_ADDRESS_INFO'

// order
export const POST_ORDER_INFO = 'POST_ORDER_INFO'
export const CHANGE_RECIPIENT_MEMBER = 'CHANGE_RECIPIENT_MEMBER'
export const EDITMESSAGEARRAY = 'EDITMESSAGEARRAY'
export const EDIT_SERVICE_MESSAGE_ARRAY = 'EDIT_SERVICE_MESSAGE_ARRAY'
// pay
export const UNIFIED_PAYMENT = 'UNIFIED_PAYMENT' // 统一下单接口

// common
export const GET_USER_INFO_BY_CODE = 'GET_USER_INFO_BY_CODE' // 根据access_token获取用户信息
export const REFRESH_TOKEN = 'REFRESH_TOKEN' // 刷新refresh_token
export const GET_PHONE_BY_UNIONID = 'GET_PHONE_BY_UNIONID' // 根据unionid获取用户手机号码
export const CHECK_ACCESS_TOKEN = 'CHECK_ACCESS_TOKEN' // 检查access_token是否有效
// confirmOrder
export const EDITRECIPIENTSTATUS = 'EDITRECIPIENTSTATUS'

// specialActivity
export const GET_SPECIAL_ACTIVITY_REQUEST = 'GET_SPECIAL_ACTIVITY_REQUEST'
export const GET_SPECIAL_ACTIVITY_SUCCESS = 'GET_SPECIAL_ACTIVITY_SUCCESS'
export const GET_SPECIAL_ACTIVITY_FAILURE = 'GET_SPECIAL_ACTIVITY_FAILURE'
export const GET_SPECIAL_ACTIVITY_RESET = 'GET_SPECIAL_ACTIVITY_RESET'
export const GET_FLOOR_LIST_REQUEST = 'GET_FLOOR_LIST_REQUEST'
export const GET_FLOOR_LIST_SUCCESS = 'GET_FLOOR_LIST_SUCCESS'
export const GET_FLOOR_LIST_FAILURE = 'GET_FLOOR_LIST_FAILURE'
export const GET_FLOOR_LIST_RESET = 'GET_FLOOR_LIST_RESET'
export const GET_SHOP_JUDGE_REQUEST = 'GET_SHOP_JUDGE_REQUEST'
export const GET_SHOP_JUDGE_SUCCESS = 'GET_SHOP_JUDGE_SUCCESS'
export const GET_SHOP_JUDGE_FAILURE = 'GET_SHOP_JUDGE_FAILURE'
export const GET_SHOP_JUDGE_RESET = 'GET_SHOP_JUDGE_RESET'

// marketingDetail
export const GET_MARKETING_ACTIVITY_REQUEST = 'GET_MARKETING_ACTIVITY_REQUEST'
export const GET_MARKETING_ACTIVITY_SUCCESS = 'GET_MARKETING_ACTIVITY_SUCCESS'
export const GET_MARKETING_FLOOR_LIST_REQUEST = 'GET_MARKETING_FLOOR_LIST_REQUEST'
export const GET_MARKETING_FLOOR_LIST_SUCCESS = 'GET_MARKETING_FLOOR_LIST_SUCCESS'

// 保养建议
export const GET_ADVICE_REQUEST = 'GET_ADVICE_REQUEST'
export const UPDATE_ADVICE_LIST = 'UPDATE_ADVICE_LIST'
export const UPDATE_NOW_SELECT_GOODS = 'UPDATE_NOW_SELECT_GOODS'
// mergeSpread
export const GET_MERGESPREAD_REQUEST = 'GET_MERGESPREAD_REQUEST'
export const GET_MERGESPREAD_SUCCESS = 'GET_MERGESPREAD_SUCCESS'
export const GET_MERGESPREAD_FLOOR_LIST_REQUEST = 'GET_MERGESPREAD_FLOOR_LIST_REQUEST'
export const GET_MERGESPREAD_FLOOR_LIST_SUCCESS = 'GET_MERGESPREAD_FLOOR_LIST_SUCCESS'
// 短信营销
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_VEHICLE_ID = 'SET_VEHICLE_ID'
export const SET_TOPIC_ID = 'SET_TOPIC_ID'
export const SET_SSTORE_ID = 'SET_SSTORE_ID'
export const SET_SMS_ID = 'SET_SMS_ID'
